<template>
  <action-dispatcher
    class="view-trail-episode py-5"
    action="trails/getLives"
    :parameters="$route.params.trail"
  >
    <div class="container text-light">
      <div class="row">
        <div class="col-lg-8 py-4">
          <video-player class="mb-4" :lesson="featured" />
          <h5 class="mb-5">{{ featured.name }}</h5>
          <comments :resource="$route.params.id" />
        </div>
        <div class="col-lg-4 py-4">
          <episodes-list :videos="lives" />
        </div>
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import get from "lodash/get";
import VideoPlayer from "@/components/lesson/VideoPlayer";
import EpisodesList from "@/components/trail/EpisodesList";
import Comments from "@/components/trail/Comments";

export default {
  components: {
    VideoPlayer,
    EpisodesList,
    Comments
  },
  computed: {
    ...mapState("trails", ["lives"]),
    resources() {
      return get(this.lesson, "resources", []);
    },
    featured() {
      return this.lives.find(video => video.id == this.$route.params.id) || {};
    }
  }
};
</script>
